module.exports = __webpack_public_path__ + "static/img/6ixty8ight.1c2d3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/6ixty8ight.png
// module id = qcNC
// module chunks = 34